module.exports = __webpack_public_path__ + "Roboto-regular.9f916e330c478bbfa2a0.eot";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-regular/Roboto-regular.eot
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-regular/Roboto-regular.eot
// module chunks = main styles